import React from "react";
import { IonItem, IonItemDivider } from "@ionic/react";
import styled from "styled-components";

const Container = styled.div``;
const DisplayContainer = styled.div`
  border: 1px solid #dbdbdb;
  margin-bottom: 8px;
`;
const DisplayLabel = styled(IonItemDivider)``;
const DisplayValue = styled(IonItem)`
  :hover {
    --background: #f0f5fc !important;
  }
  color: #666666;
`;

const DataDisplay = (props) => {
  const dataItems = props.data
    ? props.data.map((d, index) => {
        return (
          <DisplayContainer key={index}>
            <DisplayLabel color="primary">{d.label}</DisplayLabel>
            <DisplayValue>{d.value}</DisplayValue>
          </DisplayContainer>
        );
      })
    : [];

  return <Container>{dataItems}</Container>;
};

export default DataDisplay;
